import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createProtectionZone, getProtectionZone, updateProtectionZone } from "../../api/captures/protectionZone";
import { ProtectionZoneForm } from "../../types/forms/capture";

export const useCaptureProtectionZone = (captureIdStr?: string) => {
  const queryClient = useQueryClient();
  const captureId = Number(captureIdStr);

  const queryKey = ["capture", captureId, "protection-zone"];

  const result = useQuery({
    queryKey,
    queryFn: () => getProtectionZone(captureId),
    enabled: !!captureId,
  });

  const createMutation = useMutation({
    mutationFn: (values: ProtectionZoneForm) => createProtectionZone(captureId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ zoneId, values }: { zoneId: number; values: ProtectionZoneForm }) => updateProtectionZone(captureId, zoneId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return {
    protectionZoneData: result.data ?? null,
    isPending: result.isPending,
    isError: result.isError,
    error: result.error,
    createProtectionZone: createMutation.mutateAsync,
    updateProtectionZone: updateMutation.mutateAsync,
    isUpdating: createMutation.isPending || updateMutation.isPending,
  };
};
